// extracted by mini-css-extract-plugin
export default {"hidden":"downloadHoardPDFModal_hidden__OcQo1"};